<template>
  <div id="side-menu" :class="toggleMenuClass">
    <div class="menu-icon-wrapper" @click="toggleMenu">
      <svg
        width="22"
        height="18"
        viewBox="0 0 22 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        v-if="!sideMenuOpened"
      >
        <path d="M1 1H21" stroke="white" stroke-width="2" stroke-linecap="round" />
        <path d="M1 17H21" stroke="white" stroke-width="2" stroke-linecap="round" />
        <path d="M1 9H21" stroke="white" stroke-width="2" stroke-linecap="round" />
      </svg>
      <svg
        width="22"
        height="18"
        viewBox="0 0 22 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        v-else
      >
        <path d="M1 1H21" stroke="white" stroke-width="2" stroke-linecap="round" />
        <path d="M1 17H21" stroke="white" stroke-width="2" stroke-linecap="round" />
        <path d="M1 9H11" stroke="white" stroke-width="2" stroke-linecap="round" />
      </svg>
    </div>

    <div class="profile-data-wrapper">
      <div class="profile-img-wrapper">
        <profile-image />
      </div>

      <div class="select-profile-data-wrapper">
        <span class="menu-text-item" v-if="getUserData && sideMenuOpened">
          {{ getUserData.email }}
        </span>
        <svg
          class="select-profile-data-icon"
          width="10"
          height="6"
          viewBox="0 0 10 6"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M5 6L0.669873 -8.15666e-07L9.33013 -5.85621e-08L5 6Z" fill="#CFD0D1" />
        </svg>
      </div>
    </div>

    <div class="menu-items-wrapper" :class="{ 'disable-cursor-not-allowed': userDoesNotHaveSites }">
      <div
        class="menu-item-main-wrapper"
        :class="{ 'disable-pointer-event-none': userDoesNotHaveSites }"
        :title="$t('routes.desktop')"
        @click="clickMenu({ name: 'Desktop' })"
      >
        <router-link
          :to="{ name: 'Desktop' }"
          :class="{ active: menuDesktopActive }"
          class="menu-item-wrapper not-sub-menu"
          id="menu-Desktop"
        >
          <svg
            width="12"
            height="12"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect width="8.38095" height="7.61905" rx="1" fill="#CFD0D1" />
            <rect y="9.14282" width="8.38095" height="6.85714" rx="1" fill="#CFD0D1" />
            <rect x="9.65076" y="7.61902" width="6.09524" height="8.38095" rx="1" fill="#CFD0D1" />
            <rect
              class="not-change-fill change-stroke"
              x="10.1508"
              y="0.5"
              width="5.09524"
              height="5.09524"
              rx="0.5"
              stroke="#CFD0D1"
            />
          </svg>

          <span class="menu-text-item" v-if="sideMenuOpened">
            {{ $t('routes.desktop') }}
          </span>
        </router-link>
      </div>

      <div
        class="menu-item-main-wrapper"
        :class="{ 'disable-pointer-event-none': userDoesNotHaveSites }"
        :title="$t('routes.leads')"
        @click="clickMenu({ name: 'leads' })"
      >
        <router-link
          :to="{ name: 'leads' }"
          id="menu-leads"
          class="menu-item-wrapper"
          :class="{
            'sub-items-show': sub_menus.leads,
            active: menuLeadsActive,
            'arrow-revert': sub_menus.leads && sideMenuOpened && menuLeadsActive
          }"
        >
          <svg
            width="12"
            height="12"
            viewBox="0 0 18 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              class="change-stroke not-change-fill"
              d="M15.2312 1.43052L15.2311 1.43043C14.6146 0.814082 13.8567 0.5 12.9852 0.5C12.1137 0.5 11.3557 0.81406 10.7393 1.43048L10.7393 1.4305C10.1229 2.04702 9.80872 2.80491 9.80872 3.67645C9.80872 4.47947 10.0754 5.186 10.5994 5.77427H10.4304C9.34794 5.77427 8.47046 6.65175 8.47046 7.73418V8.53208C8.47046 8.89941 8.57369 9.25934 8.76837 9.57083L9.19237 9.30584L8.76837 9.57084L9.79043 11.2061C10.1486 11.7792 10.7767 12.1273 11.4524 12.1273H14.4174C15.0687 12.1273 15.6775 11.8037 16.0419 11.2639L17.1645 9.60069C17.3832 9.2768 17.5 8.89494 17.5 8.50417V7.73418C17.5 6.65175 16.6225 5.77427 15.5401 5.77427H15.3711C15.8951 5.186 16.1617 4.47949 16.1617 3.67645C16.1617 2.80493 15.8476 2.04702 15.2312 1.43052Z"
              stroke="#CFD0D1"
            />
            <path
              class="change-stroke"
              d="M7.26074 1.43052L7.26065 1.43043C6.64413 0.814082 5.88624 0.5 5.01475 0.5C4.14329 0.5 3.38526 0.81406 2.76885 1.43048L2.76884 1.4305C2.1524 2.04702 1.83826 2.80491 1.83826 3.67645C1.83826 4.47947 2.10489 5.186 2.62896 5.77427H2.45991C1.37748 5.77427 0.5 6.65175 0.5 7.73418V8.53208C0.5 8.89941 0.603228 9.25934 0.79791 9.57083L1.22191 9.30584L0.79791 9.57084L1.81997 11.2061C2.17812 11.7792 2.80621 12.1273 3.48197 12.1273H6.44694C7.09825 12.1273 7.70702 11.8037 8.07141 11.2639L9.19409 9.60069C9.41272 9.2768 9.52953 8.89494 9.52953 8.50417V7.73418C9.52953 6.65175 8.65205 5.77427 7.56962 5.77427H7.4006C7.92462 5.186 8.19128 4.47949 8.19128 3.67645C8.19128 2.80493 7.87711 2.04702 7.26074 1.43052Z"
              fill="#CFD0D1"
              stroke="#CFD0D1"
            />
            <path
              d="M11.246 4.08738L11.2459 4.08729C10.6294 3.47094 9.87147 3.15686 8.99998 3.15686C8.12852 3.15686 7.37049 3.47092 6.75408 4.08734L6.75407 4.08736C6.13763 4.70388 5.82349 5.46177 5.82349 6.33331C5.82349 7.13633 6.09012 7.84286 6.61419 8.43113H6.44514C5.36271 8.43113 4.48523 9.30861 4.48523 10.391V11.1889C4.48523 11.5563 4.58846 11.9162 4.78314 12.2277L5.20714 11.9627L4.78314 12.2277L5.8052 13.863C6.16335 14.436 6.79144 14.7842 7.4672 14.7842H10.4322C11.0835 14.7842 11.6922 14.4606 12.0566 13.9208L13.1793 12.2576C13.3979 11.9337 13.5148 11.5518 13.5148 11.161V10.391C13.5148 9.30861 12.6373 8.43113 11.5549 8.43113H11.3858C11.9098 7.84286 12.1765 7.13635 12.1765 6.33331C12.1765 5.46179 11.8623 4.70388 11.246 4.08738Z"
              fill="#CFD0D1"
              stroke="#2C3236"
            />
          </svg>

          <span class="menu-text-item" v-if="sideMenuOpened">
            {{ $t('routes.leads') }}
          </span>
        </router-link>

        <div
          @click.stop
          class="sub-items-wrapper"
          :class="{ 'is-open': sub_menus.leads && sideMenuOpened && menuLeadsActive }"
        >
          <div class="sub-items-inner">
            <router-link
              :to="{ name: 'allleads' }"
              class="sub-item"
              :class="{ active: subMenuAllLeadsActive }"
            >
              <div>
                {{ $t('routes.allleads') }}
              </div>
            </router-link>
            <router-link
              :to="{ name: 'segments' }"
              class="sub-item"
              :class="{ active: subMenuSegmentsActive }"
            >
              <div>
                {{ $t('routes.segments') }}
              </div>
            </router-link>
          </div>
        </div>
      </div>

      <div
        class="menu-item-main-wrapper"
        :class="{ 'disable-pointer-event-none': userDoesNotHaveSites }"
        :title="$t('routes.instruments')"
        @click="clickMenu({ name: 'instruments' })"
      >
        <router-link
          :to="{ name: 'instruments' }"
          id="menu-instruments"
          class="menu-item-wrapper"
          :class="{
            'sub-items-show': sub_menus.instruments,
            active: menuInstrumentsActive,
            'arrow-revert': sub_menus.instruments && sideMenuOpened && menuInstrumentsActive
          }"
        >
          <svg
            width="12"
            height="12"
            viewBox="0 0 14 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              class="change-stroke"
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M11.1222 4.28436C11.1221 4.23158 11.1078 4.17968 11.0807 4.1344L10.6155 3.3594C10.5581 3.26367 10.5422 3.14863 10.5716 3.0409L10.971 1.57622C11.0195 1.39803 11.1814 1.27441 11.3661 1.27441L11.9455 1.27443C12.1303 1.27443 12.2921 1.39808 12.3407 1.57629L12.7396 3.04012C12.7689 3.1477 12.7531 3.26257 12.6958 3.35823L12.2311 4.13411C12.2039 4.17955 12.1894 4.23148 12.1894 4.28436L12.1894 9.54308C12.823 9.76943 13.2764 10.3749 13.2764 11.0862L13.2764 17.6389C13.2764 18.5437 12.5429 19.2771 11.6382 19.2771C10.7334 19.2771 10 18.5437 10 17.6389L10 11.0862C10 10.3618 10.4702 9.74716 11.1221 9.53096L11.1222 4.28436ZM11.064 10.9109C11.2902 10.9147 11.4705 11.1011 11.4666 11.3272L11.4481 17.3098C11.4443 17.5359 11.2579 17.7162 11.0318 17.7124C10.8056 17.7085 10.6254 17.5221 10.6292 17.296L10.6477 11.3135C10.6515 11.0873 10.8379 10.9071 11.064 10.9109Z"
              fill="#CFD0D1"
            />
            <path
              class="change-stroke"
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M0.959625 5.36652C-0.319875 4.08702 -0.319875 2.01254 0.959625 0.733036C1.28851 0.404156 1.66991 0.159812 2.07683 0V2.13131C2.07683 2.58368 2.44355 2.9504 2.89592 2.9504L3.71502 2.9504C4.16739 2.9504 4.53411 2.58368 4.53411 2.13131V0.0235103C4.91919 0.183377 5.27996 0.419886 5.59311 0.733036C6.87261 2.01254 6.87261 4.08702 5.59311 5.36652C5.42776 5.53187 5.24913 5.67585 5.06066 5.79846C4.92343 5.88774 4.83222 6.03619 4.83222 6.19991V13.8001C4.83222 13.9638 4.92343 14.1123 5.06066 14.2015C5.24913 14.3242 5.42776 14.4681 5.59311 14.6335C6.87261 15.913 6.87261 17.9875 5.59311 19.267C5.26423 19.5958 4.88282 19.8402 4.4759 20V17.8687C4.4759 17.4163 4.10918 17.0496 3.65681 17.0496H2.83772C2.38535 17.0496 2.01863 17.4163 2.01863 17.8687L2.01863 19.9765C1.63355 19.8166 1.27278 19.5801 0.959625 19.267C-0.319875 17.9875 -0.319875 15.913 0.959625 14.6335C1.08277 14.5103 1.21328 14.399 1.34974 14.2996C1.47453 14.2087 1.55585 14.0671 1.55585 13.9127L1.55585 6.08731C1.55585 5.9329 1.47453 5.79134 1.34974 5.7004C1.21328 5.60096 1.08277 5.48966 0.959625 5.36652Z"
              fill="#CFD0D1"
            />
          </svg>

          <span class="menu-text-item" v-if="sideMenuOpened">
            {{ $t('routes.instruments') }}
          </span>
        </router-link>

        <div
          @click.stop
          class="sub-items-wrapper"
          :class="{ 'is-open': sideMenuOpened && sub_menus.instruments && menuInstrumentsActive }"
        >
          <div class="sub-items-inner">
          <router-link
            :to="{ name: 'message_campaigns_list' }"
            class="sub-item"
            :class="{ active: subMenuMessageCampaignsListActive }"
          >
            <div>
              {{ $t('routes.emails') }}
            </div>
          </router-link>

          <router-link
            :to="{ name: 'autocast_list' }"
            class="sub-item"
            :class="{ active: subMenuAutocastListActive }"
          >
            <div>
              {{ $t('routes.autocast') }}
            </div>
          </router-link>

          <router-link
            :to="{ name: 'widget_list' }"
            class="sub-item"
            :class="{ active: subMenuWidgetListActive }"
          >
            <div>
              {{ $t('routes.widgets') }}
            </div>
          </router-link>

          <router-link
            :to="{ name: 'user_alerts_list' }"
            v-if="!isMobile && userHavePermission('edit_alerts')"
            class="sub-item"
            :class="{ active: subMenuUserAlertsListActive }"
          >
            <div>
              {{ $t('instruments.alerts.user_alerts') }}
            </div>
          </router-link>

          <router-link
            :to="{ name: 'product_subscriptions' }"
            class="sub-item"
            :class="{ active: subMenuProductSubscriptionsActive }"
          >
            <div>
              {{ $t('instruments.subscriptions.product_subscriptions') }}
            </div>
          </router-link>

          <router-link
            :to="{ name: 'pipeline' }"
            v-if="showPipeline"
            class="sub-item"
            :class="{ active: subMenuPipelineActive }"
          >
            <div>
              {{ $t('routes.pipeline') }}
            </div>
          </router-link>

          <div
            :class="doubleSubItemsClass('loyalty')"
            @click.stop="sub_menus.loyalty = !sub_menus.loyalty"
          >
            <div class="double_sub_main">
              {{ $t('instruments.loyalty.loyalty') }}
            </div>
            <svg
              v-if="!sub_menus.loyalty"
              width="10"
              height="10"
              viewBox="0 0 10 10"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M5 1V9" stroke="#FF4402" stroke-linecap="round" />
              <path d="M9 5L1 5" stroke="#FF4402" stroke-linecap="round" />
            </svg>

            <div
              @click.stop
              class="double-sub-items"
              :class="{ 'is-open': sideMenuOpened && sub_menus.loyalty && menuInstrumentsActive }"
            >
              <div class="double-sub-items-inner">
              <router-link
                @click.stop
                :to="{ name: 'loyalty_categories' }"
                class="sub-item"
                :class="{ active: subMenuLoyaltyCategoriesActive }"
              >
                <div>
                  {{ $t('categories') }}
                </div>
              </router-link>

              <router-link
                @click.stop
                :to="{ name: 'loyalty_rules' }"
                class="sub-item"
                :class="{ active: subMenuLoyaltyRulesActive }"
              >
                <div>
                  {{ $t('instruments.loyalty.rules') }}
                </div>
              </router-link>
              </div>
            </div>
          </div>

          <div
            :class="doubleSubItemsClass('recommendation')"
            v-if="userHavePermission('view_recommendations')"
            @click.stop="sub_menus.recommendation = !sub_menus.recommendation"
          >
            <div class="double_sub_main">
              {{ $t('routes.product_recommendations') }}
            </div>
            <svg
              v-if="!sub_menus.recommendation"
              width="10"
              height="10"
              viewBox="0 0 10 10"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M5 1V9" stroke="#FF4402" stroke-linecap="round" />
              <path d="M9 5L1 5" stroke="#FF4402" stroke-linecap="round" />
            </svg>

            <div
              @click.stop
              class="double-sub-items"
              :class="{
                'is-open': sideMenuOpened && sub_menus.recommendation && menuInstrumentsActive
              }"
            >
              <div class="double-sub-items-inner">
              <router-link
                @click.stop
                :to="{ name: 'ListProductRecommendation' }"
                class="sub-item"
                :class="{ active: subMenuListProductRecommendationActive }"
              >
                <div>
                  {{ $t('routes.recommendations') }}
                </div>
              </router-link>

              <router-link
                @click.stop
                :to="{ name: 'ListBusinessRules' }"
                class="sub-item"
                :class="{ active: subMenuListBusinessRulesActive }"
              >
                <div>
                  {{ $t('routes.bisness_rules') }}
                </div>
              </router-link>
              </div>
            </div>
          </div>
          </div>
        </div>
      </div>

      <div
        class="menu-item-main-wrapper"
        :class="{ 'disable-pointer-event-none': userDoesNotHaveSites }"
        :title="$t('routes.reports')"
        v-if="userHavePermission('reports')"
        @click="clickMenu({ name: 'reports' })"
      >
        <router-link
          :to="{ name: 'reports' }"
          class="menu-item-wrapper"
          id="menu-reports"
          :class="{
            'sub-items-show': sub_menus.reports,
            active: menuReportsActive,
            'arrow-revert': sub_menus.reports && sideMenuOpened && menuReportsActive
          }"
        >
          <svg
            width="12"
            height="12"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M1.33333 0C0.596924 0 0 0.596944 0 1.33333V14.6667C0 15.403 0.596924 16 1.33333 16H9.33333H10.6667H13.3333C14.8061 16 15.3333 14.8061 15.3333 13.3333V6C15.3333 5.63182 15.0348 5.33333 14.6667 5.33333H12V1.33333C12 0.596944 11.4031 0 10.6667 0H1.33333ZM14.6667 6H12V14C12 14.7364 12.5969 15.3333 13.3333 15.3333C14.0697 15.3333 14.6667 14.7364 14.6667 14V6ZM2.33333 6.83333C2.33333 6.55719 2.48257 6.33333 2.66667 6.33333H8C8.1841 6.33333 8.33333 6.55719 8.33333 6.83333C8.33333 7.10948 8.1841 7.33333 8 7.33333H2.66667C2.48257 7.33333 2.33333 7.10948 2.33333 6.83333ZM2.73333 3.66667C2.51242 3.66667 2.33333 3.89052 2.33333 4.16667C2.33333 4.44281 2.51242 4.66667 2.73333 4.66667H5.93333C6.15425 4.66667 6.33333 4.44281 6.33333 4.16667C6.33333 3.89052 6.15425 3.66667 5.93333 3.66667H2.73333ZM2.33333 9.5C2.33333 9.22386 2.53232 9 2.77778 9H9.88889C10.1343 9 10.3333 9.22386 10.3333 9.5C10.3333 9.77614 10.1343 10 9.88889 10H2.77778C2.53232 10 2.33333 9.77614 2.33333 9.5ZM2.73333 11.6667C2.51242 11.6667 2.33333 11.8905 2.33333 12.1667C2.33333 12.4428 2.51242 12.6667 2.73333 12.6667H5.93333C6.15425 12.6667 6.33333 12.4428 6.33333 12.1667C6.33333 11.8905 6.15425 11.6667 5.93333 11.6667H2.73333Z"
              fill="#CFD0D1"
            />
          </svg>

          <span class="menu-text-item" v-if="sideMenuOpened">
            {{ $t('routes.reports') }}
          </span>
        </router-link>

        <div
          @click.stop
          class="sub-items-wrapper"
          :class="{ 'is-open': sideMenuOpened && sub_menus.reports && menuReportsActive }"
        >
          <div class="sub-items-inner">
          <router-link
            :to="{ name: 'recommendation_report' }"
            class="sub-item"
            :class="{ active: subMenuRecommendationReportActive }"
          >
            <div>
              {{ $t('side_menu.by_recommendations') }}
            </div>
          </router-link>
          
          <router-link
            :to="{ name: 'emails_report' }"
            v-if="!isMobile"
            class="sub-item"
            :class="{ active: subMenuEmailsReportActive }"
          >
            <div>
              {{ $t('side_menu.by_emails') }}
            </div>
          </router-link>

          <router-link
            :to="{ name: 'autocasts_report' }"
            v-if="!isMobile"
            :class="{ active: subMenuAutocastReportActive }"
            class="sub-item"
          >
            <div>
              {{ $t('side_menu.by_autocasts') }}
            </div>
          </router-link>

          <router-link
            :to="{ name: 'efficiency_leadhit' }"
            class="sub-item"
            :class="{ active: subMenuEfficiencyleadhitActive }"
          >
            <div>
              {{ $t('side_menu.by_efficiency_leadhit') }}
            </div>
          </router-link>

          <router-link
            :to="{ name: 'consolidated_report' }"
            class="sub-item"
            :class="{ active: subMenuConsolidatedReportActive }"
          >
            <div>
              {{ $t('side_menu.consolidated_report') }}
            </div>
          </router-link>

          <div :class="doubleSubItemsClass('by_orders')">
            <div class="double_sub_main" @click.stop="sub_menus.by_orders = !sub_menus.by_orders">
              {{ $t('reports.by_orders') }}
            </div>
            <svg
              v-if="!sub_menus.by_orders"
              width="10"
              height="10"
              viewBox="0 0 10 10"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M5 1V9" stroke="#FF4402" stroke-linecap="round" />
              <path d="M9 5L1 5" stroke="#FF4402" stroke-linecap="round" />
            </svg>
            <div
              class="double-sub-items"
              :class="{ 'is-open': sideMenuOpened && sub_menus.by_orders && menuReportsActive }"
            >
              <div class="double-sub-items-inner">
              <router-link
                @click.stop
                :to="{ name: 'by_orders_statistics' }"
                class="sub-item"
                :class="{ active: subMenuByOrdersStatisticsActive }"
              >
                <div>
                  {{ $t('reports.sources_of_orders') }}
                </div>
              </router-link>

              <router-link
                @click.stop
                :to="{ name: 'all_orders' }"
                class="sub-item"
                :class="{ active: subMenuAllOrdersActive }"
              >
                <div>
                  {{ $t('routes.all_orders') }}
                </div>
              </router-link>
              </div>
            </div>
          </div>
          </div>
        </div>
      </div>

      <div
        class="menu-item-main-wrapper"
        :class="{ 'disable-pointer-event-none': userDoesNotHaveSites }"
        :title="$t('routes.analytics')"
        @click="clickMenu({ name: 'analytics' })"
      >
        <router-link
          :to="{ name: 'analytics' }"
          :class="{
            active: menuAnalyticsActive,
            'sub-items-show': sub_menus.analytics,
            'arrow-revert': sub_menus.analytics && sideMenuOpened && menuAnalyticsActive
          }"
          id="menu-analytics"
          class="menu-item-wrapper"
        >
          <svg
            width="12"
            height="12"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M7.52533 2.13495L7.92912 4.75634C7.97569 5.0588 8.10826 5.31331 8.2925 5.51301C6.0077 6.04642 4.30604 8.09398 4.30604 10.5385C4.30604 13.3887 6.61949 15.6993 9.4733 15.6993C11.9085 15.6993 13.9502 14.0169 14.4968 11.7524C14.7067 11.9585 14.979 12.1089 15.3067 12.1635L17.8625 12.5889C18.169 12.6399 18.4794 12.5926 18.75 12.4651C17.859 16.7667 14.0443 20 9.4733 20C4.24134 20 0 15.7639 0 10.5385C0 5.93224 3.29571 2.0948 7.66047 1.25C7.52943 1.51871 7.47807 1.82825 7.52533 2.13495Z"
              fill="#C4C4C4"
            />
            <path
              class="change-stroke not-change-fill"
              d="M9.67552 3.62376L9.25463 0.91511L9.54739 0.517345C9.7386 0.505842 9.93136 0.5 10.1256 0.5C15.3076 0.5 19.5 4.65794 19.5 9.77656C19.5 10.0078 19.4915 10.2371 19.4747 10.464L19.4744 10.4676C19.4744 10.468 19.4744 10.4684 19.4743 10.4688C19.4599 10.6282 19.2954 10.7829 19.0621 10.7445L16.3981 10.3048C16.1986 10.2719 16.0116 10.0657 16.0116 9.77656C16.0116 6.55059 13.3717 3.94389 10.1256 3.94389C9.8669 3.94389 9.69944 3.77761 9.67552 3.62378C9.67552 3.62377 9.67552 3.62377 9.67552 3.62376ZM9.25463 0.915102C9.22043 0.695016 9.37161 0.527924 9.54739 0.517345L9.25463 0.915102Z"
              stroke="#CFD0D1"
            />
          </svg>

          <span class="menu-text-item" v-if="sideMenuOpened">
            {{ $t('routes.analytics') }}
          </span>
        </router-link>

        <div
          @click.stop
          class="sub-items-wrapper"
          :class="{ 'is-open': sideMenuOpened && sub_menus.analytics && menuAnalyticsActive }"
        >
          <div class="sub-items-inner">
          <router-link
            :to="{ name: 'analytics_visits' }"
            class="sub-item"
            :class="{ active: subMenuAnalyticsVisitsActive }"
          >
            <div>
              {{ $t('side_menu.by_visits') }}
            </div>
          </router-link>
          <router-link
            :to="{ name: 'analytics_leads' }"
            class="sub-item"
            :class="{ active: subMenuAnalyticsLeadsActive }"
          >
            <div>
              {{ $t('side_menu.by_leads') }}
            </div>
          </router-link>
          <router-link
            :to="{ name: 'analytics_emails' }"
            class="sub-item"
            :class="{ active: subMenuAnalyticsEmailsActive }"
          >
            <div>
              {{ $t('side_menu.by_emails') }}
            </div>
          </router-link>
          <router-link
            :to="{ name: 'analytics_widgets' }"
            class="sub-item"
            :class="{ active: subMenuAnalyticsWidgetsActive }"
          >
            <div>
              {{ $t('side_menu.by_widgets') }}
            </div>
          </router-link>
          <router-link
            :to="{ name: 'analytics_recommendations' }"
            class="sub-item"
            :class="{ active: subMenuAnalyticsRecommendationsActive }"
          >
            <div>
              {{ $t('side_menu.by_recommendations') }}
            </div>
          </router-link>
          <router-link
            :to="{ name: 'analytics_emails_dynamics' }"
            class="sub-item"
            :class="{ active: subMenuAnalyticsEmailsDynamicsActive }"
          >
            <div>
              {{ $t('side_menu.by_emails_dynamic') }}
            </div>
          </router-link>
          <router-link
            :to="{ name: 'analytics_autocasts' }"
            class="sub-item"
            :class="{ active: subMenuAnalyticsAutocastsActive }"
          >
            <div>
              {{ $t('side_menu.by_autocasts') }}
            </div>
          </router-link>
          <router-link
            :to="{ name: 'analytics_sales_funnel' }"
            class="sub-item"
            :class="{ active: subMenuAnalyticsSalesFunnelActive }"
          >
            <div>
              {{ $t('side_menu.by_sales_funnel') }}
            </div>
          </router-link>
          <router-link
            :to="{ name: 'analytics_sales' }"
            class="sub-item"
            :class="{ active: subMenuAnalyticsSalesActive }"
          >
            <div>
              {{ $t('side_menu.by_sales') }}
            </div>
          </router-link>
          <router-link
            :to="{ name: 'analytics_offers' }"
            class="sub-item"
            :class="{ active: subMenuAnalyticsOffersActive }"
          >
            <div>
              {{ $t('side_menu.by_offers') }}
            </div>
          </router-link>
          <router-link
            v-if="showRfm"
            :to="{ name: 'analytics_rfm' }"
            class="sub-item"
            :class="{ active: subMenuAnalyticsRfmActive }"
          >
            <div>
              {{ $t('side_menu.rfm_analysis') }}
            </div>
          </router-link>

          <div :class="doubleSubItemsClass('kpi')">
            <div class="double_sub_main" @click.stop="sub_menus.kpi = !sub_menus.kpi">KPI</div>
            <svg
              v-if="!sub_menus.kpi"
              width="10"
              height="10"
              viewBox="0 0 10 10"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M5 1V9" stroke="#FF4402" stroke-linecap="round" />
              <path d="M9 5L1 5" stroke="#FF4402" stroke-linecap="round" />
            </svg>
            <div
              class="double-sub-items"
              :class="{ 'is-open': sideMenuOpened && sub_menus.kpi }"
            >
              <div class="double-sub-items-inner">
              <router-link
                @click.stop
                :to="{ name: 'analytics_kpi_arpv' }"
                class="sub-item"
                :class="{ active: subMenuKPIArpvActive }"
              >
                <div>APRV</div>
              </router-link>

              <router-link
                @click.stop
                :to="{ name: 'analytics_kpi_arpl' }"
                class="sub-item"
                :class="{ active: subMenuKPIArplActive }"
              >
                <div>ARPL</div>
              </router-link>

              <router-link
                @click.stop
                :to="{ name: 'analytics_kpi_arppu' }"
                class="sub-item"
                :class="{ active: subMenuKPIArppuActive }"
              >
                <div>ARPPU</div>
              </router-link>

              <router-link
                @click.stop
                :to="{ name: 'analytics_kpi_average_check' }"
                class="sub-item"
                :class="{ active: subMenuKPIAverageCheckActive }"
              >
                <div>
                  {{ $t('routes.average_check') }}
                </div>
              </router-link>

              <router-link
                @click.stop
                :to="{ name: 'analytics_kpi_purchase_rate' }"
                class="sub-item"
                :class="{ active: subMenuKPIPurchaseRateActive }"
              >
                <div>
                  {{ $t('routes.purchase_rate') }}
                </div>
              </router-link>

              <router-link
                @click.stop
                :to="{ name: 'analytics_kpi_returned_customers' }"
                class="sub-item"
                :class="{ active: subMenuKPIReturnedCustomersActive }"
              >
                <div>
                  {{ $t('routes.returned_customers') }}
                </div>
              </router-link>

              <router-link
                @click.stop
                :to="{ name: 'analytics_kpi_car' }"
                class="sub-item"
                :class="{ active: subMenuKPICarActive }"
              >
                <div>CAR</div>
              </router-link>

              <router-link
                @click.stop
                :to="{ name: 'analytics_kpi_paid_offers_rate' }"
                class="sub-item"
                :class="{ active: subMenuKPIPaidOffersRateActive }"
              >
                <div>
                  {{ $t('routes.paid_offers_rate') }}
                </div>
              </router-link>
              </div>
            </div>
          </div>
          </div>
        </div>
      </div>

      <div
        class="menu-item-main-wrapper"
        :class="{ 'disable-pointer-event-none': userDoesNotHaveSites }"
        :title="$t('routes.library')"
        @click="clickMenu({ name: 'library' })"
      >
        <router-link
          :to="{ name: 'library' }"
          id="menu-library"
          class="menu-item-wrapper"
          :class="{
            active: menuLibraryActive,
            'sub-items-show': sub_menus.library,
            'arrow-revert': sub_menus.library && sideMenuOpened && menuLibraryActive
          }"
        >
          <svg
            width="12"
            height="12"
            viewBox="0 0 21 19"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0 9V8C0 7.44772 0.447715 7 1 7H3.5C4.05228 7 4.5 7.44772 4.5 8C4.5 8.55228 4.94772 9 5.5 9H13C13.5523 9 14 9.44772 14 10V18C14 18.5523 13.5523 19 13 19H1C0.447716 19 0 18.5523 0 18V9Z"
              fill="#CFD0D1"
            />
            <path
              d="M3 3.5C2.72386 3.5 2.5 3.72386 2.5 4C2.5 4.27614 2.72386 4.5 3 4.5V3.5ZM16.5 17.5C16.5 17.7761 16.7239 18 17 18C17.2761 18 17.5 17.7761 17.5 17.5H16.5ZM3 4.5H6V3.5H3V4.5ZM8 6.5H16V5.5H8V6.5ZM16.5 7V17.5H17.5V7H16.5ZM16 6.5C16.2761 6.5 16.5 6.72386 16.5 7H17.5C17.5 6.17157 16.8284 5.5 16 5.5V6.5ZM6.5 5C6.5 5.82843 7.17157 6.5 8 6.5V5.5C7.72386 5.5 7.5 5.27614 7.5 5H6.5ZM6 4.5C6.27614 4.5 6.5 4.72386 6.5 5H7.5C7.5 4.17157 6.82843 3.5 6 3.5V4.5Z"
              fill="#CFD0D1"
            />
            <path
              d="M6 0.5C5.72386 0.5 5.5 0.723858 5.5 1C5.5 1.27614 5.72386 1.5 6 1.5V0.5ZM19.5 16.5C19.5 16.7761 19.7239 17 20 17C20.2761 17 20.5 16.7761 20.5 16.5H19.5ZM6 1.5H9V0.5H6V1.5ZM11 3.5H19V2.5H11V3.5ZM19.5 4V16.5H20.5V4H19.5ZM19 3.5C19.2761 3.5 19.5 3.72386 19.5 4H20.5C20.5 3.17157 19.8284 2.5 19 2.5V3.5ZM9.5 2C9.5 2.82843 10.1716 3.5 11 3.5V2.5C10.7239 2.5 10.5 2.27614 10.5 2H9.5ZM9 1.5C9.27614 1.5 9.5 1.72386 9.5 2H10.5C10.5 1.17157 9.82843 0.5 9 0.5V1.5Z"
              fill="#CFD0D1"
            />
          </svg>

          <span class="menu-text-item" v-if="sideMenuOpened">
            {{ $t('routes.library') }}
          </span>
        </router-link>

        <div
          @click.stop
          class="sub-items-wrapper"
          :class="{ 'is-open': sideMenuOpened && sub_menus.library && menuLibraryActive }"
        >
          <div class="sub-items-inner">
            <router-link
              :to="{ name: 'image' }"
              class="sub-item"
              :class="{ active: subMenuImageActive }"
            >
              <div>
                {{ $t('routes.image') }}
              </div>
            </router-link>
            <router-link
              :to="{ name: 'emails_templates' }"
              class="sub-item"
              :class="{ active: subMenuEmailsTemplatesActive }"
            >
              <div>
                {{ $t('routes.emails_templates') }}
              </div>
            </router-link>
            <router-link
              :to="{ name: 'promocodes' }"
              class="sub-item"
              :class="{ active: subMenuPromocodesActive }"
            >
              <div>
                {{ $t('routes.promotional_codes') }}
              </div>
            </router-link>
          </div>
        </div>
      </div>

      <div
        class="menu-item-main-wrapper"
        :class="{ 'disable-pointer-event-none': userDoesNotHaveSites }"
        :title="$t('routes.integration')"
        @click="clickMenu({ name: 'integration' })"
      >
        <router-link
          :to="{ name: 'integration' }"
          class="menu-item-wrapper not-sub-menu"
          :class="{ active: menuIntegrationActive }"
        >
          <svg
            width="12"
            height="12"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M5.33331 10.5V14.3333C5.33331 14.8855 5.78103 15.3333 6.33331 15.3333H14.3333C14.8856 15.3333 15.3333 14.8855 15.3333 14.3333V6.33325C15.3333 5.78097 14.8856 5.33325 14.3333 5.33325H10.5V6.33325H14.3333V14.3333H6.33331V10.5H5.33331Z"
              fill="#C4C4C4"
            />
            <path
              d="M0 1C0 0.447715 0.447715 0 1 0H9C9.55228 0 10 0.447715 10 1V9C10 9.55228 9.55229 10 9 10H1C0.447715 10 0 9.55229 0 9V1Z"
              fill="#C4C4C4"
            />
            <path
              class="not-change-fill"
              d="M5 5.5C5 5.22386 5.22386 5 5.5 5H9V8.5C9 8.77614 8.77614 9 8.5 9H5V5.5Z"
              fill="#2C3236"
            />
          </svg>

          <span class="menu-text-item" v-if="sideMenuOpened">
            {{ $t('routes.integration') }}
          </span>
        </router-link>
      </div>
    </div>

    <div class="emulate-brand-icon"></div>

    <div class="brand-icon-mini-wrapper" v-if="!sideMenuOpened">
      <LeadhitLogo mini />
    </div>
    <div class="brand-icon-name-wrapper" v-else>
      <LeadhitLogo :width="107" :height="30" white />
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapMutations, mapState } from 'vuex'
  import LeadhitLogo from '@/components/ui_elements/LeadhitLogo.vue'
  import ProfileImage from '@/assets/profile_image'
  import { PIPELINE_TEST_SITE_ID, isRfmAvailable } from '@/components/instruments/pipeline/testSite'

  export default {
    name: 'SideMenu',
    components: {
      LeadhitLogo,
      ProfileImage
    },
    data() {
      return {
        sub_menus: {
          instruments: false,
          recommendation: false,
          library: false,
          leads: false,
          allEmails: false,
          reports: false,
          analytics: false,
          kpi: false,
          by_orders: false,
          loyalty: false
        },
        currentRouteName: null
      }
    },
    computed: {
      ...mapGetters(['userDoesNotHaveSites', 'userPermissions', 'getUserData', 'getSiteId']),
      ...mapState({
        sideMenuOpened: 'side_menu_mode',
        isMobile: 'is_mobile_or_tablet'
      }),
      showPipeline() {
        return this.getSiteId === PIPELINE_TEST_SITE_ID
      },
      showRfm() {
        return isRfmAvailable(this.getSiteId)
      },
      toggleMenuClass() {
        return this.sideMenuOpened ? 'shown' : 'hidden'
      },
      menuDesktopActive() {
        return this.$route.name === 'Desktop'
      },
      menuLeadsActive() {
        return this.$route.meta.menu.includes('leads')
      },
      subMenuAllLeadsActive() {
        return this.$route.meta.menu.includes('allleads')
      },
      subMenuSegmentsActive() {
        return this.$route.meta.menu.includes('segments')
      },
      menuInstrumentsActive() {
        return this.$route.meta.menu.includes('instruments')
      },
      subMenuMessageCampaignsListActive() {
        return this.$route.meta.menu.includes('message_campaigns_list')
      },
      subMenuAutocastListActive() {
        return this.$route.meta.menu.includes('autocast_list')
      },
      subMenuWidgetListActive() {
        return this.$route.meta.menu.includes('widget_list')
      },
      subMenuLoyaltyCategoriesActive() {
        return this.$route.meta.menu.includes('loyalty_categories')
      },
      subMenuLoyaltyRulesActive() {
        return this.$route.meta.menu.includes('loyalty_rules')
      },
      subMenuUserAlertsListActive() {
        return this.$route.meta.menu.includes('user_alerts')
      },
      subMenuProductSubscriptionsActive() {
        return this.$route.meta.menu.includes('product_subscriptions')
      },
      subMenuPipelineActive() {
        return this.$route.meta.menu.includes('pipeline')
      },
      menuReportsActive() {
        return this.$route.meta.menu.includes('reports')
      },
      subMenuRecommendationReportActive() {
        return this.$route.meta.menu.includes('recommendation_report')
      },
      subMenuConsolidatedReportActive() {
        return this.$route.meta.menu.includes('consolidated_report')
      },
      subMenuEmailsReportActive() {
        return this.$route.meta.menu.includes('emails_report')
      },
      subMenuAutocastReportActive() {
        return this.$route.meta.menu.includes('autocasts_report')
      },
      subMenuEfficiencyleadhitActive() {
        return this.$route.meta.menu.includes('efficiency_leadhit')
      },
      subMenuByOrdersStatisticsActive() {
        return this.$route.meta.menu.includes('by_orders_statistics')
      },
      subMenuAllOrdersActive() {
        return this.$route.meta.menu.includes('all_orders')
      },
      subMenuListProductRecommendationActive() {
        return this.$route.meta.menu.includes('ListProductRecommendation')
      },
      subMenuListBusinessRulesActive() {
        return this.$route.meta.menu.includes('ListBusinessRules')
      },
      menuAnalyticsActive() {
        return this.$route.meta.menu.includes('analytics')
      },
      subMenuAnalyticsVisitsActive() {
        return this.$route.meta.menu.includes('analytics_visits')
      },
      subMenuAnalyticsLeadsActive() {
        return this.$route.meta.menu.includes('analytics_leads')
      },
      subMenuAnalyticsEmailsActive() {
        return this.$route.meta.menu.includes('analytics_emails')
      },
      subMenuAnalyticsWidgetsActive() {
        return this.$route.meta.menu.includes('analytics_widgets')
      },
      subMenuAnalyticsRecommendationsActive() {
        return this.$route.meta.menu.includes('analytics_recommendations')
      },
      subMenuAnalyticsEmailsDynamicsActive() {
        return this.$route.meta.menu.includes('analytics_emails_dynamics')
      },
      subMenuAnalyticsAutocastsActive() {
        return this.$route.meta.menu.includes('analytics_autocasts')
      },
      subMenuAnalyticsSalesFunnelActive() {
        return this.$route.meta.menu.includes('analytics_sales_funnel')
      },
      subMenuAnalyticsSalesActive() {
        return this.$route.meta.menu.includes('analytics_sales')
      },
      subMenuAnalyticsOffersActive() {
        return this.$route.meta.menu.includes('analytics_offers')
      },
      subMenuAnalyticsRfmActive() {
        return this.$route.meta.menu.includes('analytics_rfm')
      },
      subMenuKPIArpvActive() {
        return this.$route.meta.menu.includes('kpi_arpv')
      },
      subMenuKPIArplActive() {
        return this.$route.meta.menu.includes('kpi_arpl')
      },
      subMenuKPIArppuActive() {
        return this.$route.meta.menu.includes('kpi_arppu')
      },
      subMenuKPIAverageCheckActive() {
        return this.$route.meta.menu.includes('kpi_average_check')
      },
      subMenuKPIPurchaseRateActive() {
        return this.$route.meta.menu.includes('kpi_purchase_rate')
      },
      subMenuKPIReturnedCustomersActive() {
        return this.$route.meta.menu.includes('kpi_returned_customers')
      },
      subMenuKPICarActive() {
        return this.$route.meta.menu.includes('kpi_car')
      },
      subMenuKPIPaidOffersRateActive() {
        return this.$route.meta.menu.includes('kpi_paid_offers_rate')
      },
      menuLibraryActive() {
        return this.$route.meta.menu.includes('library')
      },
      subMenuImageActive() {
        return this.$route.meta.menu.includes('image')
      },
      subMenuEmailsTemplatesActive() {
        return this.$route.meta.menu.includes('emails_templates')
      },
      subMenuPromocodesActive() {
        return this.$route.meta.menu.includes('promocodes')
      },
      menuIntegrationActive() {
        return this.$route.name === 'integration'
      }
    },
    methods: {
      ...mapMutations(['toggleSideMenuMode']),
      userHavePermission(permission) {
        return this.userPermissions.includes(permission)
      },
      clickMenu(route) {
        if (this.currentRouteName !== route.name || !this.sideMenuOpened) {
          this.sub_menus[route.name] = true
        } else {
          this.sub_menus[route.name] = !this.sub_menus[route.name]
        }

        this.currentRouteName = route.name
        this.toggleSideMenuMode(true)
      },
      toggleMenu() {
        this.toggleSideMenuMode(!this.sideMenuOpened)
      },
      doubleSubItemsClass(doubleProperty) {
        let result

        if (doubleProperty === 'loyalty' && this.$route.meta.menu.includes('loyalty')) {
          result = true
        }

        if (doubleProperty === 'kpi' && this.$route.meta.menu.includes('analytics_kpi')) {
          result = true
        }

        if (doubleProperty === 'by_orders' && this.$route.meta.menu.includes('by_orders')) {
          result = true
        }

        if (
          doubleProperty === 'recommendation' &&
          this.$route.meta.menu.includes('recommendation')
        ) {
          result = true
        }

        return result ? 'double-sub-items-wrapper double_sub_shown' : 'double-sub-items-wrapper'
      }
    },
    mounted() {
      this.currentRouteName = this.$route.name
      setTimeout(() => (this.sub_menus[this.$route.meta.menu[0]] = true), 0)
    }
  }
</script>

<style lang="scss" scoped>
  #side-menu {
    background: #2c3236;
    color: #cfd0d1;
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    position: relative;
    min-height: 100vh;
    left: 0;
    right: 0;
    top: 0;
    max-width: 160px;
    z-index: 100;
  }
  .hidden {
    width: 80px;
  }
  .shown {
    min-width: 160px;
  }
  .menu-icon-wrapper {
    background: #ff4402;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }

  .menu-item-wrapper {
    height: 40px;
    display: flex;
    align-items: center;
    position: relative;
    cursor: pointer;

    &:before {
      content: '';
      position: absolute;
      right: 20px;
      top: calc(50% - 2px);
      border: 4px solid transparent;
      border-top: 4px solid #cfd0d1;
      transition: 0.3s;
    }

    &.active:before {
      border-top: 4px solid #ff4402;
    }

    &:hover:before {
      border-top: 4px solid #ff4402;
    }

    &.arrow-revert:before {
      border-top: 4px solid #ff4402;
      transform: rotate(180deg);
      top: calc(50% - 6px);
    }

    &:after {
      content: '';
      background: #ff4402;
      width: 4px;
      height: 100%;
      border-radius: 3px;
      position: absolute;
      right: 0;
      opacity: 0;
      transition: 0.3s;
    }

    &.active:after {
      opacity: 1;
    }

    &.not-sub-menu:before {
      display: none;
    }
  }

  .profile-data-wrapper {
    padding-top: 50px;
  }
  .profile-img-wrapper {
    width: 50px;
    display: flex;
    height: 50px;
    align-items: center;
    border-radius: 25px;
    justify-content: center;
    border: 2px solid #ff4402;
    margin: 0 auto;

    img {
      width: 30px;
    }
  }
  .menu-items-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .sub-items-wrapper,
  .double-sub-items {
    display: grid;
    grid-template-rows: 0fr;
    transition: grid-template-rows 0.25s ease;
    overflow: hidden;
  }

  .sub-items-wrapper.is-open,
  .double-sub-items.is-open {
    grid-template-rows: 1fr;
  }

  .sub-items-wrapper:not(.is-open),
  .double-sub-items:not(.is-open) {
    pointer-events: none;
  }

  .sub-items-inner,
  .double-sub-items-inner {
    overflow: hidden;
    min-height: 0;
  }

  .emulate-brand-icon {
    height: 80px;
  }

  .hidden {
    .select-profile-data-wrapper {
      border-top: 1px solid #cfd0d1;
      width: 50px;
      margin: 0 auto;
      margin-top: 10px;
      display: flex;
      justify-content: center;
      padding: 10px 0 15px;
    }

    .menu-item-wrapper {
      min-width: 80px;
      padding-left: 30px;
      margin-bottom: 8px;
    }
    .menu-item-arrow-icon {
      padding-left: 10px;
    }
    .menu-item-right-side-icon {
      opacity: 0;
      margin-left: 16px;
    }
    .one-item {
      margin-left: 34px;
    }

    .menu-item-wrapper:hover {
      box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
      transition: 0.3s;

      .menu-item-right-side-icon {
        opacity: 1;
        transition: 0.3s;
      }
    }
    .active {
      box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
      transition: 0.3s;
      color: white;

      .menu-item-right-side-icon {
        opacity: 1;
        transition: 0.3s;
      }
    }
  }

  .shown {
    .select-profile-data-wrapper {
      align-items: center;
      margin: 0 auto;
      margin-top: 10px;
      display: flex;
      justify-content: center;
      padding: 10px 0 15px;

      svg {
        margin-left: 5px;
      }
    }

    .sub-items-show svg.menu-item-arrow-icon {
      path {
        fill: #ff4402;
        stroke: #ff4402;
      }
    }

    .menu-item-main-wrapper {
      width: 100%;
    }
    .menu-item-wrapper {
      padding-left: 12px;
      margin-bottom: 12px;
    }
    .menu-text-item {
      margin-left: 7px;
      color: #cfd0d1;
    }
    .menu-item-arrow-icon {
      fill: #cfd0d1;
      position: absolute;
      right: 10px;
    }
    .menu-item-right-side-icon {
      opacity: 0;
      position: absolute;
      right: 0px;
    }
    .sub-items-wrapper {
      font-size: 10px;
      position: relative;
      margin-left: 10px;

      .sub-items-inner {
        padding-left: 23px;
      }

      .double-sub-items-wrapper {
        border: 1px solid #ff4402;
        border-radius: 3px;
        padding: 3px 0 3px 20px;
        margin-bottom: 10px;
        margin-left: -20px;
        position: relative;
        margin-right: 10px;

        svg {
          position: absolute;
          right: 10px;
          top: calc(50% - 5px);
        }
      }

      .double_sub_main,
      .double_sub_main + svg {
        cursor: pointer;
      }

      .double_sub_shown {
        div.double_sub_main {
          color: #ff4402;
          cursor: pointer;
        }
      }
      .double-sub-items-inner {
        padding-top: 10px;

        div {
          margin-bottom: 6px;
          cursor: pointer;
          width: 115px;
        }
        div:hover {
          border-right: 3px solid #ff4402;
          color: #ff4402;
        }
      }
    }
    .sub-items-wrapper {
      .sub-item div:hover:not(.double-sub-items-wrapper),
      .sub-item.active div:not(.double-sub-items-wrapper) {
        color: #ff4402;
        border-right: 3px solid #ff4402;
      }
      .sub-item div:not(.double-sub-items-wrapper) {
        margin-bottom: 10px;
        cursor: pointer;
        width: 95%;
      }
    }

    .menu-item-wrapper:hover {
      box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
      transition: 0.3s;
      color: white;

      &:after {
        opacity: 1;
      }

      .menu-item-arrow-icon path {
        fill: #ff4402;
        stroke: #ff4402;
      }

      .menu-item-right-side-icon {
        opacity: 1;
        transition: 0.3s;
      }
    }
    .active {
      box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
      transition: 0.3s;
      color: white;

      .menu-item-arrow-icon path {
        fill: #ff4402;
        stroke: #ff4402;
      }
      .menu-item-right-side-icon {
        opacity: 1;
        transition: 0.3s;
      }
    }
  }

  .menu-item-wrapper.active,
  .menu-item-wrapper:hover {
    svg {
      *:not(.not-change-fill) {
        fill: #ff4402 !important;
      }
      *.change-stroke {
        stroke: #ff4402 !important;
      }
    }
  }

  .brand-icon-mini-wrapper {
    position: absolute;
    bottom: 50px;
    width: 80px;
    display: flex;
    justify-content: center;
  }
  .brand-icon-name-wrapper {
    position: absolute;
    bottom: 50px;
    left: 30px;
    width: 80px;
    display: flex;
    justify-content: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/main/SideMenu.vue